export { ncWalletApi, walletApi } from './api';
